import {
  GET_PULL_EVENT_LOGS_LIST,
  GET_PUSH_EVENT_LOGS_LIST,
  TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP,
} from 'src/redux/Actions/Type';

const initialState = {
  pullEventLogList: [],
  pushEventLogList: [],
  triggerManualSyncEventsFromSap: {},
};

export default function eventLogSyncReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case GET_PULL_EVENT_LOGS_LIST:
      return {
        ...state,
        pushEventLogList: [],
        pullEventLogList: payload,
      };
    case GET_PUSH_EVENT_LOGS_LIST:
      return {
        ...state,
        pullEventLogList: [],
        pushEventLogList: payload,
      };
    case TRIGGER_MANUAL_SYNC_EVENTS_FROM_SAP:
      return {
        ...state,
        triggerManualSyncEventsFromSap: payload,
      };
    default:
      return state;
  }
}
